import { useState, createContext, useEffect, ReactNode } from 'react';
import { ChainStore } from '@/types/chain';
import { getChainList } from '@/services/chain';
import { useWallet } from '@/hooks/wallet';

export const ChainInfoContext = createContext<{
  isFetching: boolean;
  chainStore: ChainStore;
}>({
  isFetching: true,
  chainStore: {},
});

ChainInfoContext.displayName = 'ChainInfoContext';
interface Props {
  children: ReactNode;
}

export const ChainInfoProvider = (props: Props) => {
  const { children } = props;
  const [chainStore, setChainStore] = useState<ChainStore>({});
  const [isFetching, setIsFetching] = useState(true);
  const { isThird } = useWallet();

  const fetchChainInfo = async () => {
    const newChainStore: ChainStore = {};
    const { result, success } = await getChainList();

    if (success) {
      if (isThird) {
        result.walletChains.MNEMONIC_PHRASE.itemList.forEach((item) => {
          newChainStore[item.chainCode] = item;
        });
      }

      if (!isThird) {
        result.walletChains.CLOUD.itemList.forEach((item) => {
          newChainStore[item.chainCode] = item;
        });
      }

      setChainStore(newChainStore);
    }
    setIsFetching(false);
  };

  useEffect(() => {
    fetchChainInfo();
  }, []);

  return (
    <ChainInfoContext.Provider
      value={{
        isFetching,
        chainStore,
      }}
    >
      {children}
    </ChainInfoContext.Provider>
  );
};
